import { useLocaleContext } from './LocaleProvider'

/**
 * Access translations: `const { t, locale, setLocale } = useTranslation()`.
 * `t('rail.title')` or `t('shipping.subtitle', { count })`.
 */
export function useTranslation() {
  return useLocaleContext()
}
